var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-inspection"},[_c('div',{staticClass:"policy-title"},[_vm._v(" 保单验真 ")]),_c('div',{staticClass:"policy-list"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"policy-item"},[_c('div',{staticClass:"policy-content",domProps:{"innerHTML":_vm._s(item.html)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }